import React, { Component } from "react";
import { connect } from "react-redux";
import { getTransactionsTotal } from "../../../actions/transactionsActions";
import TransactionsBalance from '../TransactionsBalance';

import "./TransactionsTotal.scss";
import RenderField from "../../HelperComponents/RenderField/RenderField";
import { splitByCommas } from "../../../helpers/functions";

const today = new Date().toISOString().split("T")[0];

class TransactionsTotal extends Component {
  state = {
    date: today,
    total: {},
  };

  componentDidMount = () => {
    this.fetchTotal();
  };

  fetchTotal = () => {
    const { getTransactionsTotal, role } = this.props;
    const { date } = this.state;

    getTransactionsTotal({ date, role }).then(({ payload }) => {
      if (payload.status === 200) {
        this.setState({ total: payload.data });
      }
    });
  };

  handleChangeDate = (event) => {
    const newDate = event.target.value;
    this.setState({ date: newDate }, () => {
      this.fetchTotal();
    });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.role !== this.props.role) {
      this.fetchTotal();
    }
  }

  render() {
    const { total } = this.state;

    return (
      <div className="transactions_table_wrapper">
        <div className="transactions_table">
          <div className="transactions_columns">
            <div className="table_row">
              <div className="row_item">
                <RenderField
                  id="date"
                  type="date"
                  name="date"
                  placement="start"
                  meta={{}}
                  input={{
                    defaultValue: today,
                    onChange: this.handleChangeDate,
                    size: "small",
                  }}
                />
              </div>
              <div className="row_item">
                {total.total_company_count} /{" "}
                <strong className="red_text">
                  {total.purchase_transaction_count}
                </strong>{" "}
                /{" "}
                <strong className="green_text">
                  {total.topup_transaction_count}
                </strong>
              </div>
              <div className="row_item">
                <strong className="green_text">
                  {splitByCommas(total.total_topup_amount)}&nbsp;₽
                </strong>{" "}
                /{" "}
                <strong className="red_text">
                  {splitByCommas(total.total_purchase_amount)}&nbsp;₽
                </strong>
              </div>
              <div className="row_item transactions_totals_balance">
                <TransactionsBalance balance={total.total_balance} overdue={total.total_overdue_debt} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  getTransactionsTotal,
};

export default connect(undefined, mapDispatchToProps)(TransactionsTotal);
